import { compositionOverlayUnit, socialPresentationInsets } from '../../../renderer/src/social-geometry';
import type { SocialVideoPresentation } from '../../../renderer/src/social-presentation';
import type { CameraPadding } from '../domain/camera-plan';

/** Camera padding changes the subject framing, never the full-frame map viewport. */
export function socialCameraPadding(root: HTMLElement, presentation: SocialVideoPresentation, width: number, height: number): CameraPadding {
  const unit = compositionOverlayUnit(width, height);
  const insets = socialPresentationInsets(presentation, width, height);
  const origin = root.getBoundingClientRect();
  const upper = root.querySelector<HTMLElement>(presentation.layout === 'information-card' ? '.social-information-card' : ':scope > .social-title');
  const footer = root.querySelector<HTMLElement>('.social-footer');
  const upperBottom = upper ? upper.getBoundingClientRect().bottom - origin.top : insets.top;
  let footerTop = footer ? footer.getBoundingClientRect().top - origin.top : height - insets.bottom;
  const rail = root.querySelector<HTMLElement>('[data-social-layout="side-rail"] .social-statistics');
  // A side rail reserves horizontal space; only its full-width footer constrains vertical framing.
  if (presentation.layout === 'side-rail' && footer) {
    const fullWidth = footer.querySelector<HTMLElement>('.social-elevation, .social-playback');
    footerTop = fullWidth ? fullWidth.getBoundingClientRect().top - origin.top : footerTop;
  }
  const padding = { top: upperBottom + 32 * unit, bottom: height - footerTop + 32 * unit,
    left: (presentation.layout === 'side-rail' ? insets.left + (rail?.getBoundingClientRect().width ?? 248 * unit) : insets.left) + 32 * unit,
    right: insets.right + 32 * unit };
  // Extreme typography can fill the asset; retain a valid camera and expose measured overlap advisories.
  const scaleY = Math.min(1, (height - 96) / Math.max(1, padding.top + padding.bottom));
  const scaleX = Math.min(1, (width - 96) / Math.max(1, padding.left + padding.right));
  return { top: padding.top * scaleY, bottom: padding.bottom * scaleY, left: padding.left * scaleX, right: padding.right * scaleX };
}
